export const mockStaff = [
  {
    id: 'staff-1',
    name: 'Sarah Mitchell',
    role: 'Senior Support Worker',
    email: 'sarah.m@youthcentre.org',
    phone: '07700 123456',
    address: ['45 Oak Street', 'Flat 2B', 'Manchester', 'M1 4GH'],
    documents: [
      { name: 'DBS Certificate', status: 'valid', expiry: '2027-01-15' },
      { name: 'Safeguarding L3', status: 'expiring', expiry: '2026-03-10' }
    ],
    hoursThisWeek: 32,
    nextPayDate: '2026-02-28',
    salary: 28500,
    sickDays: { used: 3, total: 10 },
    holidays: { used: 12, total: 28 },
    safetyCerts: [
      { name: 'First Aid', status: 'valid' },
      { name: 'Safeguarding L3', status: 'expiring' }
    ],
    status: 'active'
  },
  {
    id: 'staff-2',
    name: 'Marcus Johnson',
    role: 'Youth Mentor',
    email: 'marcus.j@youthcentre.org',
    phone: '07700 234567',
    address: ['12 Victoria Road', 'Salford', 'M5 3EQ'],
    documents: [{ name: 'DBS Certificate', status: 'valid', expiry: '2027-03-01' }],
    hoursThisWeek: 40,
    nextPayDate: '2026-02-28',
    salary: 25000,
    sickDays: { used: 1, total: 10 },
    holidays: { used: 8, total: 28 },
    safetyCerts: [{ name: 'First Aid', status: 'valid' }],
    status: 'active'
  },
  {
    id: 'staff-3',
    name: 'Priya Sharma',
    role: 'Outreach Worker',
    email: 'priya.s@youthcentre.org',
    phone: '07700 345678',
    address: ['78 Canal Street', 'Manchester', 'M1 5QE'],
    documents: [{ name: 'DBS Certificate', status: 'valid', expiry: '2027-01-20' }],
    hoursThisWeek: 28,
    nextPayDate: '2026-02-28',
    salary: 26000,
    sickDays: { used: 5, total: 10 },
    holidays: { used: 15, total: 28 },
    safetyCerts: [{ name: 'Mental Health First Aid', status: 'valid' }],
    status: 'active'
  }
];

export const mockProgrammes = [
  {
    id: 'prog-1',
    name: 'Art Club',
    day: 'Monday',
    time: '16:00-18:00',
    capacity: 12,
    enrolled: 8,
    staff: 'Sarah Mitchell',
    lessonPlans: []
  },
  {
    id: 'prog-2',
    name: 'Sports Session',
    day: 'Wednesday',
    time: '16:00-19:00',
    capacity: 20,
    enrolled: 15,
    staff: 'Marcus Johnson',
    lessonPlans: []
  },
  {
    id: 'prog-3',
    name: 'Homework Club',
    day: 'Tue/Thu',
    time: '15:30-17:30',
    capacity: 15,
    enrolled: 10,
    staff: 'Priya Sharma',
    lessonPlans: []
  },
  {
    id: 'prog-4',
    name: 'Cooking Workshop',
    day: 'Thursday',
    time: '17:00-19:00',
    capacity: 8,
    enrolled: 6,
    staff: 'Sarah Mitchell',
    lessonPlans: []
  },
  {
    id: 'prog-5',
    name: 'Girls Group',
    day: 'Wednesday',
    time: '16:00-18:00',
    capacity: 10,
    enrolled: 7,
    staff: 'Priya Sharma',
    lessonPlans: []
  }
];

export const mockActivities = [
  {
    id: 'act-1',
    name: 'Museum Trip',
    date: '2026-02-18',
    time: '10:00-15:00',
    durationHours: 5,
    capacity: 12,
    enrolled: 9,
    location: 'Manchester Museum',
    lead: 'Sarah Mitchell',
    status: 'scheduled',
    notes: 'Travel by minibus, packed lunch required.',
    staffAvailability: '2 staff required',
    emergencyContact: {
      name: 'Duty Manager',
      role: 'Safeguarding Lead',
      phone: '07700 123456',
      email: 'safeguarding@centre.org'
    },
    tracker: {
      provider: 'Apple AirTag',
      id: 'AT-22-104',
      notes: 'Assigned to group kit bag'
    },
    safeguarding: {
      consentRequired: true,
      consentStatus: 'pending',
      riskAssessmentComplete: false,
      medicalNotes: 'Allergy list attached.',
      safeguardingNotes: 'Meet at reception, staff to student ratio enforced.',
      supervisionRatio: '1:3',
      transportPlan: 'Minibus pickup at 09:15',
      meetingPoint: 'Reception desk',
      collectionPlan: 'Main gate',
      emergencyPlan: 'Regroup at reception, call duty manager, notify guardians.'
    },
    fees: { courseFee: 0, eventFee: 5, otherFee: 0 },
    templates: [{ id: 'tpl-act-1', title: 'Briefing', duration: '30m', focus: 'Safety' }],
    documents: [
      { id: 'doc-act-1', name: 'Risk Assessment', expiryDate: null, fileName: 'risk-assessment.pdf' }
    ],
    lessonPlans: []
  },
  {
    id: 'act-2',
    name: 'Community Clean-Up',
    date: '2026-02-05',
    time: '14:00-17:00',
    durationHours: 3,
    capacity: 18,
    enrolled: 14,
    location: 'Salford Quays',
    lead: 'Marcus Johnson',
    status: 'completed',
    notes: 'Partnered with local council.',
    staffAvailability: '1 staff required',
    emergencyContact: {
      name: 'On-site Coordinator',
      role: 'Volunteer Lead',
      phone: '07900 222333',
      email: 'coordinator@community.org'
    },
    tracker: {
      provider: '',
      id: '',
      notes: ''
    },
    safeguarding: {
      consentRequired: false,
      consentStatus: 'not-required',
      riskAssessmentComplete: true,
      medicalNotes: '',
      safeguardingNotes: 'Provide hi-vis and gloves.',
      supervisionRatio: '1:4',
      transportPlan: 'Walk from centre to site',
      meetingPoint: 'Community hall entrance',
      collectionPlan: 'Return to centre by 17:15',
      emergencyPlan: 'Contact coordinator and duty manager in emergencies.'
    },
    fees: { courseFee: 0, eventFee: 0, otherFee: 0 },
    templates: [],
    documents: [],
    lessonPlans: []
  },
  {
    id: 'act-3',
    name: 'CV Workshop',
    date: '2026-02-22',
    time: '16:30-18:00',
    durationHours: 1.5,
    capacity: 20,
    enrolled: 11,
    location: 'Training Room',
    lead: 'Priya Sharma',
    status: 'scheduled',
    notes: 'Bring laptops if possible.',
    staffAvailability: '1 staff required',
    emergencyContact: {
      name: 'Front Desk',
      role: 'Reception',
      phone: '0161 111 2222',
      email: 'frontdesk@centre.org'
    },
    tracker: {
      provider: '',
      id: '',
      notes: ''
    },
    safeguarding: {
      consentRequired: true,
      consentStatus: 'received',
      riskAssessmentComplete: true,
      medicalNotes: '',
      safeguardingNotes: 'Ensure quiet space available.',
      supervisionRatio: '1:5',
      transportPlan: 'On-site',
      meetingPoint: 'Training room lobby',
      collectionPlan: 'Reception sign-out',
      emergencyPlan: 'Escalate to on-call manager.'
    },
    fees: { courseFee: 0, eventFee: 0, otherFee: 0 },
    templates: [{ id: 'tpl-act-3', title: 'CV review', duration: '1h', focus: 'Employability' }],
    documents: [],
    lessonPlans: []
  }
];

export const VULNERABILITIES = {
  mental_health: {
    label: 'Mental Health',
    color: 'bg-purple-500',
    lightBg: 'bg-purple-50',
    abbr: 'MH'
  },
  home_issues: {
    label: 'Home Issues',
    color: 'bg-orange-500',
    lightBg: 'bg-orange-50',
    abbr: 'HI'
  },
  housing: {
    label: 'Housing',
    color: 'bg-blue-500',
    lightBg: 'bg-blue-50',
    abbr: 'HS'
  },
  food: {
    label: 'Food Poverty',
    color: 'bg-amber-500',
    lightBg: 'bg-amber-50',
    abbr: 'FP'
  },
  crime_prevention: {
    label: 'Crime Prevention',
    color: 'bg-red-500',
    lightBg: 'bg-red-50',
    abbr: 'CP'
  },
  drug_prevention: {
    label: 'Substance Misuse',
    color: 'bg-rose-600',
    lightBg: 'bg-rose-50',
    abbr: 'SM'
  }
};

export const mockStudents = [
  {
    id: 'stu-1',
    reference: 'SP-1001',
    name: 'Jamie Thompson',
    dob: '2010-05-12',
    age: 15,
    pronouns: 'he/him',
    school: 'Manchester Academy',
    status: 'Under Review',
    financeStatus: 'outstanding',
    riskLevel: 'high',
    finance: { courseFees: 350, eventFees: 75, otherFees: 20 },
    vulnerabilities: ['mental_health', 'home_issues'],
    address: ['45 Oak Street', 'Flat 2B', 'Manchester', 'M1 4GH'],
    keyWorker: {
      id: 'staff-1',
      name: 'Sarah Mitchell',
      notes: 'Building trust through weekly sessions.',
      goals: ['Improve attendance', 'Develop coping strategies']
    },
    localAuthority: 'Children\'s Services',
    contacts: [
      {
        id: 'con-1',
        type: 'guardian',
        name: 'Michelle Thompson',
        role: 'Parent / Guardian',
        phone: '07800 333444',
        email: 'michelle.thompson@example.com',
        notes: 'Primary contact'
      },
      {
        id: 'con-2',
        type: 'social_worker',
        name: 'Claire Williams',
        role: 'Social Worker',
        phone: '0161 234 5678',
        email: 'claire.williams@la.org',
        notes: 'Children\'s Services team'
      }
    ],
    attendance: {
      scheduled: ['Mon', 'Wed', 'Fri'],
      rate: 85,
      trend: 'improving',
      last8Weeks: [78, 80, 82, 85, 84, 88, 90, 92],
      absenceReasons: [
        { date: '2026-01-20', reason: 'Medical appointment' },
        { date: '2026-01-27', reason: 'Family issues' }
      ]
    },
    safeguardingEvents: [
      {
        id: 'saf-1',
        category: 'Social Care',
        type: 'Disclosure',
        severity: 'high',
        status: 'open',
        description: 'Parents separating - distress reported.',
        date: '2026-01-15',
        assignedOwner: 'Sarah Mitchell',
        reviewDate: '2026-02-12',
        escalationLevel: 'L2',
        attachments: ['case-note-0115.pdf'],
        createdBy: 'Sarah Mitchell',
        createdAt: '2026-01-15T10:15:00Z',
        updatedAt: '2026-01-22T09:30:00Z',
        visibility: ['Admin', 'Manager', 'Staff']
      }
    ],
    medicalEvents: [
      {
        id: 'med-1',
        category: 'Medical',
        type: 'Anxiety Episode',
        severity: 'moderate',
        status: 'closed',
        description: 'Panic attack during session.',
        date: '2025-12-01',
        assignedOwner: 'Sarah Mitchell',
        reviewDate: null,
        escalationLevel: 'L1',
        attachments: [],
        createdBy: 'Sarah Mitchell',
        createdAt: '2025-12-01T15:20:00Z',
        updatedAt: '2025-12-01T15:20:00Z',
        visibility: ['Admin', 'Manager', 'Staff']
      }
    ],
    policeEvents: [],
    documents: [
      {
        id: 'doc-1',
        name: 'Initial Assessment',
        tags: ['assessment', 'safeguarding'],
        dueDate: '2026-02-15',
        expiryDate: '2026-03-15',
        visibility: ['Admin', 'Manager', 'Staff'],
        versions: [
          {
            version: 1,
            uploadedBy: 'Sarah Mitchell',
            uploadedAt: '2025-11-18',
            fileName: 'assessment-v1.pdf'
          }
        ],
        metadata: {
          type: 'PDF',
          size: '1.2MB'
        }
      }
    ],
    certificates: [
      {
        id: 'cert-1',
        name: 'Participation Award',
        issueDate: '2025-12-05',
        expiryDate: null,
        fileName: 'award.pdf'
      }
    ],
    supportReviews: [
      {
        id: 'rev-1',
        title: 'Quarterly support plan review',
        dueDate: '2026-02-20',
        assignedTo: 'Sarah Mitchell',
        status: 'open',
        notes: 'Review attendance improvements and wellbeing.',
        createdBy: 'Admin User',
        createdAt: '2026-01-15T09:30:00Z',
        updatedAt: '2026-01-15T09:30:00Z'
      }
    ],
    enrolments: [
      {
        id: 'enr-1',
        programme: 'Art Club',
        startDate: '2025-09-10',
        endDate: null
      }
    ],
    activities: [
      {
        id: 'act-enr-1',
        activityId: 'act-1',
        name: 'Museum Trip',
        date: '2026-02-18',
        status: 'scheduled'
      }
    ],
    statusHistory: [
      { status: 'Active', date: '2025-09-01', by: 'Admin User' },
      { status: 'Under Review', date: '2026-01-15', by: 'Sarah Mitchell' }
    ],
    lastUpdated: '2026-01-22T09:30:00Z',
    notes: [
      {
        id: 'note-1',
        content: 'Initial assessment completed. Monitor attendance closely.',
        createdAt: '2026-01-16T09:00:00Z',
        createdBy: 'Sarah Mitchell'
      }
    ]
  },
  {
    id: 'stu-2',
    reference: 'SP-1002',
    name: 'Aisha Begum',
    dob: '2011-07-19',
    age: 14,
    pronouns: 'she/her',
    school: 'Salford High',
    status: 'Active',
    financeStatus: 'clear',
    riskLevel: 'low',
    finance: { courseFees: 0, eventFees: 0, otherFees: 0 },
    vulnerabilities: ['food'],
    address: ['12 Victoria Road', 'Salford', 'M5 3EQ'],
    keyWorker: {
      id: 'staff-2',
      name: 'Marcus Johnson',
      notes: 'Natural leader.',
      goals: ['Build confidence']
    },
    localAuthority: null,
    contacts: [
      {
        id: 'con-3',
        type: 'guardian',
        name: 'Fatima Begum',
        role: 'Parent / Guardian',
        phone: '07800 444555',
        email: 'fatima.begum@example.com',
        notes: ''
      }
    ],
    attendance: {
      scheduled: ['Tue', 'Thu'],
      rate: 100,
      trend: 'stable',
      last8Weeks: [100, 100, 100, 95, 100, 100, 100, 100],
      absenceReasons: []
    },
    safeguardingEvents: [
      {
        id: 'saf-2',
        category: 'Social Care',
        type: 'Early Help',
        severity: 'low',
        status: 'monitoring',
        description: 'Food bank referral.',
        date: '2025-08-20',
        assignedOwner: 'Marcus Johnson',
        reviewDate: '2026-02-18',
        escalationLevel: 'L1',
        attachments: [],
        createdBy: 'Marcus Johnson',
        createdAt: '2025-08-20T10:10:00Z',
        updatedAt: '2025-11-12T10:10:00Z',
        visibility: ['Admin', 'Manager', 'Staff']
      }
    ],
    medicalEvents: [],
    policeEvents: [],
    documents: [],
    certificates: [],
    supportReviews: [
      {
        id: 'rev-2',
        title: 'Support review with LA',
        dueDate: '2026-02-10',
        assignedTo: 'Marcus Johnson',
        status: 'open',
        notes: 'Coordinate with local authority case worker.',
        createdBy: 'Admin User',
        createdAt: '2026-01-28T10:00:00Z',
        updatedAt: '2026-01-28T10:00:00Z'
      }
    ],
    enrolments: [
      {
        id: 'enr-2',
        programme: 'Homework Club',
        startDate: '2025-09-12',
        endDate: null
      }
    ],
    activities: [
      {
        id: 'act-enr-2',
        activityId: 'act-2',
        name: 'Community Clean-Up',
        date: '2026-02-05',
        status: 'completed'
      }
    ],
    statusHistory: [{ status: 'Active', date: '2025-09-01', by: 'Admin User' }],
    lastUpdated: '2026-01-05T14:10:00Z',
    notes: []
  },
  {
    id: 'stu-3',
    reference: 'SP-1003',
    name: 'Tyler Davies',
    dob: '2009-11-02',
    age: 16,
    pronouns: 'he/him',
    school: 'Alternative Provision',
    status: 'Active',
    financeStatus: 'outstanding',
    riskLevel: 'critical',
    finance: { courseFees: 420, eventFees: 0, otherFees: 60 },
    vulnerabilities: ['crime_prevention', 'drug_prevention', 'mental_health'],
    address: ['78 Canal Street', 'Manchester', 'M1 5QE'],
    keyWorker: {
      id: 'staff-3',
      name: 'Priya Sharma',
      notes: 'Working on anger management.',
      goals: ['Complete YOT', 'Reduce substance use']
    },
    localAuthority: 'Youth Justice',
    contacts: [
      {
        id: 'con-4',
        type: 'guardian',
        name: 'Robert Davies',
        role: 'Parent / Guardian',
        phone: '07800 555666',
        email: 'robert.davies@example.com',
        notes: ''
      },
      {
        id: 'con-5',
        type: 'representative',
        name: 'David Chen',
        role: 'Youth Offending Officer',
        phone: '0161 234 9876',
        email: 'david.chen@la.org',
        notes: 'Youth Justice team'
      }
    ],
    attendance: {
      scheduled: ['Mon', 'Wed', 'Thu', 'Fri'],
      rate: 45,
      trend: 'declining',
      last8Weeks: [60, 58, 55, 50, 48, 45, 42, 40],
      absenceReasons: [
        { date: '2026-01-12', reason: 'Unauthorised absence' },
        { date: '2026-01-19', reason: 'Unauthorised absence' }
      ]
    },
    safeguardingEvents: [
      {
        id: 'saf-3',
        category: 'Social Care',
        type: 'Risk Assessment',
        severity: 'critical',
        status: 'open',
        description: 'Multi-agency meeting scheduled.',
        date: '2026-01-25',
        assignedOwner: 'Priya Sharma',
        reviewDate: '2026-02-06',
        escalationLevel: 'L3',
        attachments: ['risk-assessment.pdf'],
        createdBy: 'Priya Sharma',
        createdAt: '2026-01-25T09:00:00Z',
        updatedAt: '2026-01-27T10:00:00Z',
        visibility: ['Admin', 'Manager']
      }
    ],
    medicalEvents: [
      {
        id: 'med-2',
        category: 'Medical',
        type: 'Substance Concern',
        severity: 'high',
        status: 'monitoring',
        description: 'Appeared intoxicated.',
        date: '2025-11-30',
        assignedOwner: 'Priya Sharma',
        reviewDate: '2026-02-10',
        escalationLevel: 'L2',
        attachments: [],
        createdBy: 'Priya Sharma',
        createdAt: '2025-11-30T16:45:00Z',
        updatedAt: '2026-01-15T10:00:00Z',
        visibility: ['Admin', 'Manager', 'Staff']
      }
    ],
    policeEvents: [
      {
        id: 'pol-1',
        category: 'Police',
        type: 'Police Caution',
        severity: 'medium',
        status: 'closed',
        description: 'Antisocial behaviour.',
        date: '2025-12-10',
        assignedOwner: 'Priya Sharma',
        reviewDate: null,
        escalationLevel: 'L1',
        attachments: [],
        createdBy: 'Priya Sharma',
        createdAt: '2025-12-10T12:00:00Z',
        updatedAt: '2025-12-10T12:00:00Z',
        visibility: ['Admin', 'Manager']
      }
    ],
    documents: [],
    certificates: [],
    enrolments: [
      {
        id: 'enr-3',
        programme: 'Sports Session',
        startDate: '2025-09-05',
        endDate: null
      }
    ],
    statusHistory: [{ status: 'Active', date: '2025-09-01', by: 'Admin User' }],
    lastUpdated: '2026-01-27T10:00:00Z',
    notes: [
      {
        id: 'note-2',
        content: 'Meeting scheduled with guardian and YOT.',
        createdAt: '2026-01-28T10:15:00Z',
        createdBy: 'Priya Sharma'
      }
    ]
  },
  {
    id: 'stu-4',
    reference: 'SP-1004',
    name: 'Sophie Chen',
    dob: '2012-03-23',
    age: 13,
    pronouns: 'she/her',
    school: "St. Mary's",
    status: 'Active',
    financeStatus: 'clear',
    riskLevel: 'medium',
    finance: { courseFees: 0, eventFees: 15, otherFees: 0 },
    vulnerabilities: ['housing', 'mental_health'],
    address: ['12 Victoria Road', 'Salford', 'M5 3EQ'],
    keyWorker: {
      id: 'staff-1',
      name: 'Sarah Mitchell',
      notes: 'Opening up gradually.',
      goals: ['Build friendships']
    },
    localAuthority: 'Housing Services',
    contacts: [
      {
        id: 'con-6',
        type: 'guardian',
        name: 'Linda Chen',
        role: 'Parent / Guardian',
        phone: '07800 666777',
        email: 'linda.chen@example.com',
        notes: ''
      },
      {
        id: 'con-7',
        type: 'representative',
        name: 'Emma Roberts',
        role: 'Housing Support',
        phone: '0161 234 1111',
        email: 'emma.roberts@la.org',
        notes: 'Housing Services team'
      }
    ],
    attendance: {
      scheduled: ['Wed', 'Fri'],
      rate: 95,
      trend: 'stable',
      last8Weeks: [95, 96, 95, 94, 97, 95, 96, 95],
      absenceReasons: []
    },
    safeguardingEvents: [
      {
        id: 'saf-4',
        category: 'Social Care',
        type: 'Housing Concern',
        severity: 'medium',
        status: 'open',
        description: 'Family facing eviction.',
        date: '2025-11-15',
        assignedOwner: 'Sarah Mitchell',
        reviewDate: '2026-02-20',
        escalationLevel: 'L1',
        attachments: ['housing-letter.pdf'],
        createdBy: 'Sarah Mitchell',
        createdAt: '2025-11-15T09:45:00Z',
        updatedAt: '2026-01-20T13:00:00Z',
        visibility: ['Admin', 'Manager', 'Staff']
      }
    ],
    medicalEvents: [],
    policeEvents: [],
    documents: [],
    certificates: [],
    enrolments: [
      {
        id: 'enr-4',
        programme: 'Girls Group',
        startDate: '2025-10-01',
        endDate: null
      }
    ],
    statusHistory: [{ status: 'Active', date: '2025-09-01', by: 'Admin User' }],
    lastUpdated: '2026-01-20T13:00:00Z',
    notes: []
  }
];

export const mockInventory = [
  {
    id: 'inv-1',
    reference: 'INV-1001',
    name: 'PlayStation 5',
    type: 'Tech Equipment',
    serialNumber: 'PS5-4492',
    condition: 'Good',
    notes: 'Console used for supervised sessions.',
    status: 'checked_out',
    assignments: [
      {
        id: 'assign-1',
        assignedToType: 'student',
        assignedToId: 'stu-1',
        assignedToName: 'Jamie Thompson',
        checkoutDate: '2026-01-20',
        dueDate: '2026-02-03',
        expectedReturnDate: '2026-02-03',
        checkinDate: null,
        notes: ''
      }
    ]
  },
  {
    id: 'inv-2',
    reference: 'INV-1002',
    name: 'First Aid Kit',
    type: 'Learning Materials',
    serialNumber: '',
    condition: 'Good',
    notes: 'Restocked monthly.',
    status: 'available',
    assignments: []
  },
  {
    id: 'inv-3',
    reference: 'INV-1003',
    name: 'Basketball Set',
    type: 'Sports Equipment',
    serialNumber: 'BB-221',
    condition: 'Fair',
    notes: '',
    status: 'checked_out',
    assignments: [
      {
        id: 'assign-2',
        assignedToType: 'staff',
        assignedToId: 'staff-2',
        assignedToName: 'Marcus Johnson',
        checkoutDate: '2026-01-29',
        dueDate: '2026-02-05',
        expectedReturnDate: '2026-02-05',
        checkinDate: null,
        notes: 'For Wednesday session.'
      }
    ]
  },
  {
    id: 'inv-4',
    reference: 'INV-1004',
    name: 'Art Supplies',
    type: 'Learning Materials',
    serialNumber: '',
    condition: 'Good',
    notes: 'Shared cabinet.',
    status: 'available',
    assignments: []
  },
  {
    id: 'inv-5',
    reference: 'INV-1005',
    name: 'Projector',
    type: 'Tech Equipment',
    serialNumber: 'PJ-991',
    condition: 'Good',
    notes: '',
    status: 'available',
    assignments: []
  },
  {
    id: 'inv-6',
    reference: 'INV-1006',
    name: 'Nintendo Switch',
    type: 'Tech Equipment',
    serialNumber: 'NS-233',
    condition: 'Fair',
    notes: 'Controller drift reported.',
    status: 'under_repair',
    assignments: []
  }
];

export const mockIncidents = [
  {
    id: 'inc-1',
    type: 'Behavioural',
    date: '2026-02-03T15:10:00Z',
    reportedBy: 'Marcus Johnson',
    description: 'Verbal altercation during session. De-escalation completed.',
    severity: 'medium',
    status: 'open',
    assignedKeyWorker: 'Sarah Mitchell',
    followUpRequired: true,
    followUpDate: '2026-02-10',
    followUpPrompt: 'Check in with student and update safeguarding notes.',
    participants: [
      { id: 'stu-2', type: 'student', name: 'Tyler Davies', role: 'Student' },
      { id: 'staff-2', type: 'staff', name: 'Marcus Johnson', role: 'Youth Mentor' }
    ],
    inventoryItemIds: ['inv-1'],
    documents: [
      { id: 'doc-1', name: 'incident-note.pdf', uploadedAt: '2026-02-03T16:00:00Z', uploadedBy: 'Marcus Johnson' }
    ]
  },
  {
    id: 'inc-2',
    type: 'Injury',
    date: '2026-01-28T11:30:00Z',
    reportedBy: 'Sarah Mitchell',
    description: 'Minor cut treated with first aid kit.',
    severity: 'low',
    status: 'closed',
    assignedKeyWorker: 'Sarah Mitchell',
    followUpRequired: false,
    followUpDate: null,
    followUpPrompt: '',
    participants: [
      { id: 'stu-1', type: 'student', name: 'Jamie Thompson', role: 'Student' },
      { id: 'staff-1', type: 'staff', name: 'Sarah Mitchell', role: 'Senior Support Worker' }
    ],
    inventoryItemIds: ['inv-2'],
    documents: []
  },
  {
    id: 'inc-3',
    type: 'Safeguarding concern',
    date: '2026-01-25T09:00:00Z',
    reportedBy: 'Priya Sharma',
    description: 'Disclosure of substance use. Safeguarding notified.',
    severity: 'high',
    status: 'monitoring',
    assignedKeyWorker: 'Priya Sharma',
    followUpRequired: true,
    followUpDate: '2026-02-08',
    followUpPrompt: 'Review safeguarding status and update risk assessment.',
    participants: [
      { id: 'stu-2', type: 'student', name: 'Tyler Davies', role: 'Student' },
      { id: 'staff-3', type: 'staff', name: 'Priya Sharma', role: 'Outreach Worker' }
    ],
    inventoryItemIds: [],
    documents: []
  }
];
